import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";

import Button from "components/library/Button";
import Popover from "components/library/Popover";
import shared from "../../../shared.css";
import styles from "./LinkChange.css";

import { removeLink } from "editor/actions/editor";
import { toggleModal } from "editor/actions/ui";
import { EDITOR_MODALS } from "config/constants/editor";
import isActiveEntity from "editor/utils/isActiveEntity";
import isEditorActive from "editor/utils/isEditorActive";
import activeEntityKey from "editor/utils/activeEntityKey";
import { ENTITY_TYPE } from "config/constants/editor";
import getActiveEditorState from "editor/utils/getActiveEditorState";

class LinkChange extends React.Component {
  constructor(props) {
    super(props);

    this.openLinkEditor = this._openLinkEditor.bind(this);
    this.removeLink = this._removeLink.bind(this);
    this.closeModal = this._closeModal.bind(this);

    this.state = { canOpen: false };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (isEditorActive(nextProps.editorState)) {
      this.setState({ canOpen: true });
    }
  }

  _openLinkEditor(e) {
    e.preventDefault();
    this.props.toggleModal(EDITOR_MODALS.LINK_EDITOR);
  }

  _removeLink(e) {
    e.preventDefault;
    this.props.removeLink();
  }

  _closeModal() {
    this.setState({ canOpen: false });
  }

  isOpened() {
    if (!this.state.canOpen) return false;
    if (
      this.props.openModal !== EDITOR_MODALS.CLOSE &&
      (isActiveEntity(this.props.editorState, ENTITY_TYPE.LINK) ||
        isActiveEntity(this.props.editorState, ENTITY_TYPE.OLD_LINK))
    )
      return false;
    return this.props.entityKey === activeEntityKey(this.props.editorState);
  }

  // Position the link change modal above the highlighted text.
  calculateOffset() {
    if (!this.props.linkEl) {
      return null;
    }

    let { top, left } = this.props.linkEl.getBoundingClientRect();
    const changeElement = document.querySelector(".link-change");
    const changeHeight = changeElement ? changeElement.clientHeight : 42;
    const spacing = parseFloat(shared["scale-3"]) * 10;

    // a buffer of spacing around the edge of the window so the popover will
    // always be positioned at least BUFFER inside the window
    const BUFFER = spacing;

    top -= changeHeight + spacing;

    // check top bound and adjust if necessary
    if (top < BUFFER) {
      top = BUFFER;
    }

    return { top, left };
  }

  displayUrl() {
    return this.props.url.length > 30
      ? `${this.props.url.slice(0, 27)}...`
      : this.props.url;
  }

  render() {
    return (
      <Popover
        className={classNames("link-change", styles.root)}
        closeModal={this.closeModal}
        isOpened={this.isOpened()}
        position={this.calculateOffset()}
      >
        <a href={this.props.url} className={styles.link} target="_blank">
          {this.displayUrl()}
        </a>
        <Button
          className={styles.button}
          name="change"
          type="tertiary"
          onClick={this.openLinkEditor}
        >
          Change
        </Button>
        <Button
          className={styles.button}
          destructive
          name="remove"
          type="tertiary"
          onClick={this.removeLink}
        >
          Remove
        </Button>
      </Popover>
    );
  }
}

const mapStateToProps = state => {
  return {
    openModal: state.editor.ui.openModal,
    editorState: getActiveEditorState(state),
  };
};

const mapDispatchToProps = {
  toggleModal,
  removeLink,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LinkChange);

LinkChange.propTypes = {
  url: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  removeLink: PropTypes.func.isRequired,
  openModal: PropTypes.oneOf(Object.values(EDITOR_MODALS)).isRequired,
  entityKey: PropTypes.string.isRequired,
  linkEl: PropTypes.instanceOf(Element),
  editorState: PropTypes.object.isRequired,
};
